// extracted by mini-css-extract-plugin
export default {"problem-text":"QuestionText_problem-text__rR7uF","done":"QuestionText_done__TTsyj","answer":"QuestionText_answer__i9Bbh"};